import styled from 'styled-components'

export const Select = styled.select`
  border: 1px solid rgba(0, 0, 0, 0.09);
  border-radius: 2px;
  height: 4rem;
  padding: 0 1rem;
`
